module.exports = __webpack_public_path__ + "sprstatic/img/xin (2).07218d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xin/xin (2).png
// module id = iq1X
// module chunks = 2